var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height"},[(_vm.isDashboardV2)?_c('ProgramDashboardV2'):_c('ProgramDashboardV1')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }